(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dinghy-event', {
            parent: 'entity',
            url: '/dinghy-event?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-event/dinghy-events.html',
                    controller: 'DinghyEventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dinghy-event-detail', {
            parent: 'dinghy-event',
            url: '/dinghy-event/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-detail.html',
                    controller: 'DinghyEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DinghyEvent', function($stateParams, DinghyEvent) {
                    return DinghyEvent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dinghy-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dinghy-event-detail.edit', {
            parent: 'dinghy-event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-dialog.html',
                    controller: 'DinghyEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyEvent', function(DinghyEvent) {
                            return DinghyEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-event.new', {
            parent: 'dinghy-event',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-dialog.html',
                    controller: 'DinghyEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                type: null,
                                fromDate: null,
                                untilDate: null,
                                contactEmail: null,
                                placeCount: null,
                                location: null,
                                identifier: null,
                                normalPrice: null,
                                studentPrice: null,
                                guestPrice: null,
                                description: null,
                                conditions: null,
                                notes: null,
                                visible: false,
                                active: false,
                                closed: false,
                                canceled: false,
                                allowGuests: false,
                                allowQueue: false,
                                individualQuestion: null,
                                uid: null,
                                version: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dinghy-event', null, { reload: 'dinghy-event' });
                }, function() {
                    $state.go('dinghy-event');
                });
            }]
        })
        .state('dinghy-event.edit', {
            parent: 'dinghy-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-dialog.html',
                    controller: 'DinghyEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyEvent', function(DinghyEvent) {
                            return DinghyEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-event', null, { reload: 'dinghy-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-event.delete', {
            parent: 'dinghy-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-delete-dialog.html',
                    controller: 'DinghyEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEvent', function(DinghyEvent) {
                            return DinghyEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-event', null, { reload: 'dinghy-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
